var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Section",
    _vm._b(
      {
        attrs: {
          title: _vm.title,
          shouldShowSearch: _vm.shouldShowSearch,
          toolbarActions: _vm.toolbarActions,
          isPrimary: _vm.isPrimary,
          icon: "construction",
          isLoading: _vm.isLoading,
        },
        on: {
          onClicked: (val) => _vm.$emit(val),
          onShouldSearch: (val) => _vm.$emit("onShouldSearch", val),
        },
        scopedSlots: _vm._u(
          [
            _vm.$slots.toolbarExtension
              ? {
                  key: "toolbarExtension",
                  fn: function () {
                    return [_vm._t("toolbarExtension")]
                  },
                  proxy: true,
                }
              : null,
          ],
          null,
          true
        ),
      },
      "Section",
      _vm.$attrs,
      false
    ),
    [
      _vm._v(" "),
      _c(
        "v-layout",
        { attrs: { column: "" } },
        [
          _c(
            "v-flex",
            [
              _c("v-data-table", {
                staticClass: "elevation-1",
                attrs: {
                  headers: _vm.headers,
                  items: _vm.assetList,
                  "item-key": "id",
                  "select-all": _vm.shouldShowCheckBoxes,
                  "hide-actions": true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "headers",
                    fn: function (props) {
                      return [
                        _c(
                          "tr",
                          [
                            _vm.shouldShowCheckBoxes
                              ? _c(
                                  "th",
                                  [
                                    _c("v-checkbox", {
                                      attrs: {
                                        "input-value": _vm.areAllSelected,
                                        indeterminate:
                                          _vm.areSomeSelected &&
                                          !_vm.areAllSelected,
                                        readonly: "",
                                        primary: "",
                                        "hide-details": "",
                                        disabled: _vm.isLoading,
                                      },
                                      nativeOn: {
                                        click: function ($event) {
                                          !_vm.isLoading
                                            ? _vm.toggleAll(props.all)
                                            : ""
                                        },
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(props.headers, function (header) {
                              return _c(
                                "th",
                                {
                                  key: header.text,
                                  staticClass: "column text-xs-left",
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(header.text) +
                                      "\n            "
                                  ),
                                ]
                              )
                            }),
                          ],
                          2
                        ),
                      ]
                    },
                  },
                  {
                    key: "items",
                    fn: function (props) {
                      return [
                        _vm.shouldShowCheckBoxes
                          ? _c(
                              "td",
                              [
                                _c("v-checkbox", {
                                  attrs: {
                                    "input-value": _vm.selectedItems.some(
                                      (i) => i.id === props.item.id
                                    ),
                                    primary: "",
                                    "hide-details": "",
                                    disabled: _vm.isLoading,
                                  },
                                  on: {
                                    change: function ($event) {
                                      return _vm.handleItemSelect(props.item)
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-left" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm._entityPropertyValueByName({
                                  entityList: _vm.assetStatusList,
                                  idKey: "id",
                                  idValue: props.item.statusId,
                                  propertyKey: "name",
                                })
                              ) +
                              "\n            "
                          ),
                          _c("br"),
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm._formatJavascriptDate({
                                  date: props.item.dateTimeStatusLastUpdated,
                                })
                              ) +
                              "\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-left" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm._entityPropertyValueByName({
                                  entityList: _vm.locationList,
                                  idKey: "id",
                                  idValue: props.item.locationId,
                                  propertyKey: "name",
                                })
                              ) +
                              "\n            "
                          ),
                          _c("br"),
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm._formatJavascriptDate({
                                  date: props.item.dateTimeLocationLastUpdated,
                                })
                              ) +
                              "\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-left" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(props.item.name) +
                              "\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-left" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm._entityPropertyValueByName({
                                  entityList: _vm.modelList,
                                  idKey: "id",
                                  idValue: props.item.modelId,
                                  propertyKey: "name",
                                })
                              ) +
                              "\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-left" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm._manufacturerByModelId({
                                  modelList: _vm.modelList,
                                  manufacturerList: _vm.manufacturerList,
                                  modelId: props.item.modelId,
                                }).name || "[UNKNOWN]"
                              ) +
                              "\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-left" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm._categoryByModelId({
                                  modelList: _vm.modelList,
                                  categoryList: _vm.categoryList,
                                  modelId: props.item.modelId,
                                }).name || "[UNKNOWN]"
                              ) +
                              "\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-left" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm._entityPropertyValueByName({
                                  entityList: _vm.clientList,
                                  idKey: "id",
                                  idValue: props.item.clientId,
                                  propertyKey: "name",
                                })
                              ) +
                              "\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c("td", { staticClass: "text-xs-left" }, [
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm._entityPropertyValueByName({
                                  entityList: _vm.activityTypeList,
                                  idKey: "id",
                                  idValue: props.item.activityTypeIdLast,
                                  propertyKey: "name",
                                })
                              ) +
                              "\n            "
                          ),
                          _c("br"),
                          _vm._v(
                            "\n            " +
                              _vm._s(
                                _vm._formatJavascriptDate({
                                  date: props.item
                                    .dateTimeActivityLastPerformed,
                                })
                              ) +
                              "\n          "
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "td",
                          { staticClass: "text-xs-right" },
                          [
                            _c("ControlButton", {
                              attrs: {
                                text: "View",
                                depressed: "",
                                disabled: _vm.isLoading,
                              },
                              on: {
                                onClicked: function ($event) {
                                  return _vm.$emit("onClickViewEquipment", {
                                    assetId: props.item.id,
                                  })
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.currentPage > 0
            ? _c(
                "v-flex",
                { staticClass: "text-xs-center", attrs: { "py-3": "" } },
                [
                  _c("v-pagination", {
                    attrs: {
                      "py-4": "",
                      value: _vm.currentPage,
                      length: _vm.numberOfPages,
                      "total-visible": 7,
                      disabled: _vm.isLoading,
                    },
                    on: { input: (val) => _vm.$emit("onClickPageChange", val) },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }